export default __webpack_public_path__ + "static/media/W.Bard-image.562e742c.png";